import {
  SellingMode as SellingModeEnum,
  type ScheduleTime,
  type Scheduling,
  type SellingMode,
  type TariffGroup,
} from '@src/core/buyerApiClient';
import { resolveDefaultTariffFromGroup } from '@src/domains/tariffs/core/resolveDefaultTariffFromGroup';
import { scheduleFieldsForSellingMode } from '@src/domains/scheduling/core/scheduleFieldsForSellingMode';
import type { ReplicatedProductSelection } from '../../types';

type SingleBookingProductSource = {
  productId: string;
  sellingMode: SellingMode | undefined;
  schedulingForDate?: Scheduling | null;
  defaultTariffGroup?: TariffGroup | null;
};

type ReplicateSingleBookingSelectionInput = {
  date: string | undefined;
  time: ScheduleTime | undefined;
  quantity: number;
  products: SingleBookingProductSource[];
};

export type ReplicateSingleBookingSelectionResult =
  | { ok: true; selections: ReplicatedProductSelection[] }
  | { ok: false; reason: 'missing_default_tariff'; productId: string };

export function replicateSingleBookingSelection({
  date,
  time,
  quantity,
  products,
}: ReplicateSingleBookingSelectionInput): ReplicateSingleBookingSelectionResult {
  const selections: ReplicatedProductSelection[] = [];

  for (const product of products) {
    const tariffGroup =
      product.sellingMode === SellingModeEnum.WithoutDate
        ? product.defaultTariffGroup
        : product.schedulingForDate?.tariffGroup ?? product.defaultTariffGroup;
    const tariff = resolveDefaultTariffFromGroup(tariffGroup);

    if (!tariff || !tariffGroup) {
      return { ok: false, reason: 'missing_default_tariff', productId: product.productId };
    }

    const schedule = scheduleFieldsForSellingMode(product.sellingMode, date, time);

    selections.push({
      productId: product.productId,
      sellingMode: product.sellingMode,
      date: schedule.date,
      time: schedule.time,
      quantity,
      tariff,
      tariffGroup,
      scheduling: schedule.date ? product.schedulingForDate ?? undefined : undefined,
    });
  }

  return { ok: true, selections };
}
